var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-icon',{attrs:{"icon":"stopwatch","font-scale":"1"}}),_c('p',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.timeLeft)+" / "+_vm._s(_vm.maxPresent))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }